import { createContext } from "react";
import type { StartPayClient } from "../core/StartPayClient";

export type StartPayContextValue = {
  client: StartPayClient;
};

export const StartPayContext = createContext<StartPayContextValue | null>(null);
